export const invoiceHeaderData = ["Product", "Quantity", "Price", "Unit", "Vat %", "Total"];

export const invoiceTwoDataList = [
    {
        image: "laptop",
        title: "Apple Desktop",
        code: "#XDG-6437",
        quantity: "2",
        price: "100",
        unit: "Hour(s)",
        vat: "0",
        total: "200",
    },
    {
        image: "watch",
        title: "Smart Watch",
        code: "#XDG-6437",
        quantity: "1",
        price: "200",
        unit: "Hour(s)",
        vat: "0",
        total: "200",
    },
    {
        image: "phone",
        title: "Apple iphone 13 Pro",
        code: "#XDG-6437",
        quantity: "1",
        price: "10,000",
        unit: "Hour(s)",
        vat: "0",
        total: "10,000",
    },
    {
        image: "headphone",
        title: "Wireless Headphone",
        code: "#XDG-6437",
        quantity: "2",
        price: "8,000",
        unit: "Hour(s)",
        vat: "0",
        total: "16,000",
    },
];

export const invoiceThreeHeader = ["Description", "Qty", "Price", "Subtotal"];

export const invoiceThreeData = [
    {
        title: "HTML Admin template",
        detail: "Regular License",
        quantity: "2",
        price: "35",
        total: "70",
        color: "#009DB5",
    },
    {
        title: "React Admin template",
        detail: "Regular License",
        quantity: "1",
        price: "25",
        total: "50",
        color: "#F99B0D",
    },
    {
        title: "Laravel Admin template",
        detail: "Regular License",
        quantity: "2",
        price: "30",
        total: "60",
        color: "#83BF6E",
    },
    {
        title: "Vuejs Admin template",
        detail: "Regular License",
        quantity: "3",
        price: "20",
        total: "60",
        color: "#F94C8E",
    },
];

export const invoiceFourDetails = [
    {
        title: "Date",
        value: "10 Mar, 2024",
    },
    {
        title: "invoice No",
        value: "#VL25000365",
    },
    {
        title: "Account No",
        value: "0981234098765",
    },
    {
        title: "Due Amount",
        value: "$7860.00",
    },
];

export const invoiceTableHeader = ["Description", "Unite Price", "Quantity", "Subtotal"];

export const invoiceFourData = [
    {
        title: "Proposal & Brochure Design",
        detail: "Regular License",
        price: "300",
        quantity: "1",
        total: "300",
    },
    {
        title: "Web design and development",
        detail: "Regular License",
        price: "400",
        quantity: "2",
        total: "800",
    },
    {
        title: "Logo & Brand  design",
        detail: "Regular License",
        price: "240",
        quantity: "2",
        total: "480",
    },
    {
        title: "Stationary Design",
        detail: "Regular License",
        price: "100",
        quantity: "1",
        total: "100",
    },
];

export const invoiceSixTable = ["Item Description", "Hours", "Rate", "Sub-total"];

export const invoiceSixData = [
    {
        title: "Red Shirt",
        detail: "Wild West - Red Cotton Blend Regular Fit Men's Formal Shirt.",
        hours: "5",
        price: "75",
        total: "375",
    },
    {
        title: "Brown Dress",
        detail: "Aask - Brown Polyester Blend Women's Fit & Flare Dress.",
        hours: "3",
        price: "75",
        total: "225",
    },
    {
        title: "Flower Dress",
        detail: "Skyblue Flower Printed Sleevless Strappy Dress.",
        hours: "10",
        price: "75",
        total: "750",
    },
    {
        title: "Red Skirt",
        detail: "R L F - Red Cotton Blend Women's A-Line Skirt.",
        hours: "10",
        price: "75",
        total: "750",
    },
];
